<template>

	<popover v-if="agenda.acknowledge" placement="right" width="350" trigger="hover">

		<button type="button" class="btn btn-block blue-soft" slot="reference">
			<i class="fa fa-eye" aria-hidden="true"></i>
			<span v-translate>Visualizado por...</span>
		</button>

		<ul class="list-group m-b-0">
			<li class="list-group-item" v-for="log in agenda.acknowledge">
				{{ log.responsible.name }} ({{ log.acknowledgeDateTime | date('DD/MM/YYYY HH:mm') }})
			</li>
		</ul>

	</popover>

</template>

<script>

	import AgendaViewers from './';
	export default AgendaViewers;

</script>



// WEBPACK FOOTER //
// agenda-viewers.vue?0e948d0f